import './index.sass';

export default () => {
  const handleClick = (elem, data) => {
    elem.attr('href', data.url)
    elem.attr('data-method', data.method);
    elem.find('.stats-info__count').html(data.count_likes);
  }
  $('.js-stats-like').on('ajax:success', function(e) {
    const $target = $(this);
    if($target.hasClass('stats-info__like--pressed')) {
      $target.removeClass('stats-info__like--pressed');
      handleClick($target, e.detail[0]);
    } else {
      $target.addClass('stats-info__like--pressed');
      handleClick($target, e.detail[0]);
    }

  })
}